import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";
import { LayoutCrudRoutes } from "@ryde/layout";

import { AreasPageContent } from "./areas.page.content";

export const AreasPage: FC = () => {
  return (
    <PageContextWrapper entity="area">
      <AreasPageContent />
      <LayoutCrudRoutes />
    </PageContextWrapper>
  );
};
